// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useQuery } from '@apollo/client/react';
import Link from 'components/common/Link';
import { Locale } from 'jsw';

import BRANDING_QUERY from 'queries/Branding.graphql';

const Brand = ({
    baseClassName = 'brand',
    className = undefined,
    href = undefined,
}) => {
    const { data: { viewer: { logo: {
        image,
        imageAlt,
        url,
        edition,
    } } } } = useQuery(BRANDING_QUERY);

    const Tag = (url || href) ? Link : 'span';

    return (
        <Tag
            className={classNames(baseClassName, className)}
            to={url || href}
            target={url ? '_blank' : undefined}
        >
            <img className={`${baseClassName}__logo`} src={image} alt={Locale.getSection('components.sidebar').lmsg('homePage', { imageAlt })} />
            {edition ? <span className={`${baseClassName}__edition`}>{edition}</span> : null}
        </Tag>
    );
};

Brand.propTypes = {
    href: PropTypes.string,
    className: PropTypes.string,
    baseClassName: PropTypes.string,
};

export default Brand;
